import React from 'react';
import './RouletteWheel.css';

const defaultColors = ['#3cb178', '#17b5c1', '#4564c4', '#7042a8', '#e27d60', '#85dcb0', '#e8a87c', '#c38d9e'];

const RouletteWheel = ({ items, rotation, onSpin, spinning, selectedItem }) => {
  const totalVisualWeight = items.reduce((sum, item) => sum + item.visualWeight, 0);
  let cumulativeAngle = 0;

  const wheelSegments = items.map(item => {
    const startAngle = cumulativeAngle;
    const angle = (item.visualWeight / totalVisualWeight) * 360;
    cumulativeAngle += angle;
    return { ...item, startAngle, angle };
  });

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        maxWidth: '560px',
        aspectRatio: '609 / 898',
        margin: 'auto',
      }}
    >


      <img
        src="/assets/roulette-frame.png"
        alt="룰렛 프레임"
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />

      {/* 🎡 회전체 */}
      <div
        style={{
          position: 'absolute',
          top: '17.5%',
          left: '50%',
          width: '100%',
          aspectRatio: '1 / 1',
          transform: `translateX(-50%) rotate(${rotation}deg)`,
          transition: 'transform 4s cubic-bezier(0.33, 1, 0.68, 1)',
          zIndex: 2,
        }}
      >
        <svg width="100%" height="100%" viewBox="0 0 1000 1000">
          {wheelSegments.map((segment, i) => {
            const { startAngle, angle, name } = segment;
            const color = defaultColors[i % defaultColors.length];
            const isWinner = selectedItem && selectedItem.name === name;

            const cx = 500;
            const cy = 500;
            const radius = 450;

            const x1 = cx + radius * Math.cos((Math.PI / 180) * startAngle);
            const y1 = cy + radius * Math.sin((Math.PI / 180) * startAngle);
            const x2 = cx + radius * Math.cos((Math.PI / 180) * (startAngle + angle));
            const y2 = cy + radius * Math.sin((Math.PI / 180) * (startAngle + angle));
            const largeArcFlag = angle > 180 ? 1 : 0;
            const midAngle = startAngle + angle / 2;

            const labelRadius = 300;
            const labelX = cx + labelRadius * Math.cos((Math.PI / 180) * midAngle);
            const labelY = cy + labelRadius * Math.sin((Math.PI / 180) * midAngle);
            const correctedAngle = (midAngle >= 90 && midAngle <= 270) ? midAngle + 180 : midAngle;

            return (
              <g key={i} className={isWinner ? 'glow' : ''}>
                <path
                  d={`M${cx},${cy} L${x1},${y1} A${radius},${radius} 0 ${largeArcFlag},1 ${x2},${y2} Z`}
                  fill={color}
                  stroke="white"
                  strokeWidth="2"
                />
                <text
                  x={labelX}
                  y={labelY}
                  fill="white"
                  fontSize="32"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  transform={`rotate(${correctedAngle}, ${labelX}, ${labelY})`}
                >
                  {name}
                </text>
              </g>
            );
          })}

          {/* START 텍스트 중심 고정 */}
          <circle cx="500" cy="500" r="100" fill="white" />
          <circle cx="500" cy="500" r="90" fill="orange" />
          <text x="500" y="516" fontSize="3rem" fontWeight="bold" fill="white" textAnchor="middle">
            START
          </text>
        </svg>
      </div>

      {/* 🟠 시작 버튼 (정중앙) */}
      <button
        onClick={onSpin}
        disabled={spinning}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '20%',
          aspectRatio: '1 / 1',
          borderRadius: '50%',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          zIndex: 7,
        }}
      />

      {/* 🔺 화살표 (12시 방향) */}
      <img
        src="/assets/roulette-frame-arrow.png"
        alt="화살표"
        style={{
          position: 'absolute',
          top: '18%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '10%',
          height: 'auto',
          zIndex: 6,
          pointerEvents: 'none',
        }}
      />
    </div>
  );
};

export default RouletteWheel;
